export default "__VITE_ASSET__mVZwwlIJ__"